import React, { useState } from 'react';
import * as Popover from '@radix-ui/react-popover';
import { Dices } from 'lucide-react';
import { DICE } from '../utils/cardActions';
import './DicePopover.css';

/**
 * Würfel-Auswahl (Spec 2026-10-21 §5.6): W4, W6, W8, W10, W12, W20, W100 und Münze.
 *
 *   <DicePopover onRoll={rollDice}>
 *     <RailButton icon={Dices} label="Würfeln" />
 *   </DicePopover>
 *
 * - `children` ist der Auslöser (Radix `Popover.Trigger asChild`): er muss Ref und Props an
 *   sein DOM-Element weiterreichen. Ohne `children` steht ein eigener Knopf (Symbol + „Würfeln").
 * - Ein Knopf je Würfel ruft `onRoll(sides)` (`sides` 4…100 oder `'coin'`) und schließt das
 *   Popover; das Ergebnis zeigt die Seite (Toast).
 */
export default function DicePopover({ onRoll, children }) {
  const [open, setOpen] = useState(false);
  return (
    <Popover.Root open={open} onOpenChange={setOpen}>
      <Popover.Trigger asChild>
        {children || (
          <button type="button" className="dice-popover__trigger">
            <Dices size={16} aria-hidden />
            <span>Würfeln</span>
          </button>
        )}
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content
          className="dice-popover"
          side="right"
          align="center"
          sideOffset={8}
          collisionPadding={8}
          aria-label="Würfeln"
        >
          {DICE.map(({ sides, label }) => (
            <button
              key={sides}
              type="button"
              className="dice-popover__die"
              onClick={() => {
                setOpen(false);
                onRoll?.(sides);
              }}
            >
              {label}
            </button>
          ))}
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
}
